// extracted by mini-css-extract-plugin
export default {"msgM":"_669d1fb7e5"};